import { CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { of, switchMap } from 'rxjs';

export const authGuard: CanActivateChildFn = (childRoute, state) => {
  const router = inject(Router);
  const authenticationService = inject(AuthenticationService);

  return authenticationService.isAuthenticated().pipe(
    switchMap(
      (status: any) => {
        if (!status) {
          router.navigate(['login']);
        }
        return of(status);
      }
    )
  );
};
